
export default function Testimonials() {
  const testimonials = [
    {
      name: '김민준',
      position: 'CEO',
      company: '테크이노베이션',
      image: 'https://public.readdy.ai/ai/img_res/9f457aea545095bd84a2a8a84fdf4f6c.jpg',
      rating: 5,
      content: 'Freeworkers의 AI 자동화 솔루션을 도입한 후 업무 효율이 눈에 띄게 향상되었습니다. 특히 고객 응대 시스템이 정말 훌륭해서 고객 만족도가 크게 올랐어요. 투자 대비 효과가 확실한 솔루션입니다.',
      date: '2024년 1월'
    },
    {
      name: '이서연',
      position: '운영 이사',
      company: '글로벌커머스',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20businesswoman%20executive%20in%20modern%20office%2C%20confident%20female%20leader%20in%20business%20attire%2C%20clean%20corporate%20headshot%20with%20simple%20background%2C%20professional%20photography%20style&width=200&height=200&seq=testimonial-002&orientation=squarish',
      rating: 5,
      content: '처음에는 AI 도입이 복잡할 것 같아 걱정했는데, Freeworkers 팀의 전문적인 지원 덕분에 매우 순조롭게 진행되었습니다. 지금은 하루 수백 건의 문의를 자동으로 처리하고 있어요. 정말 만족스럽습니다!',
      date: '2024년 2월'
    },
    {
      name: '박준호',
      position: 'CTO',
      company: '스마트솔루션즈',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20technology%20executive%20CTO%20in%20modern%20tech%20office%2C%20confident%20male%20tech%20leader%20in%20smart%20casual%20attire%2C%20clean%20corporate%20headshot%20with%20simple%20background%2C%20professional%20photography%20style&width=200&height=200&seq=testimonial-003&orientation=squarish',
      rating: 5,
      content: '다양한 AI 솔루션을 검토했지만 Freeworkers가 가장 실용적이고 효과적이었습니다. 맞춤형 솔루션 제공과 지속적인 기술 지원이 특히 인상적이었어요. 우리 회사의 디지털 전환에 핵심적인 역할을 했습니다.',
      date: '2024년 3월'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-teal-50 to-cyan-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-white rounded-full px-4 py-2 mb-4 shadow-sm">
            <i className="ri-chat-quote-line text-teal-600"></i>
            <span className="text-teal-600 text-sm font-semibold">Customer Reviews</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            고객들의 생생한 후기
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Freeworkers와 함께 비즈니스를 혁신한 고객들의 실제 경험을 들어보세요
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 flex flex-col"
            >
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed mb-6 flex-grow">
                "{testimonial.content}"
              </p>

              <div className="flex items-center space-x-4 pt-6 border-t border-gray-100">
                <div className="w-14 h-14 flex items-center justify-center">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full rounded-full object-cover object-top"
                  />
                </div>
                <div className="flex-1">
                  <div className="font-bold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.position}</div>
                  <div className="text-sm text-teal-600 font-medium">{testimonial.company}</div>
                </div>
              </div>

              <div className="mt-4 text-xs text-gray-500 flex items-center space-x-1">
                <i className="ri-calendar-line"></i>
                <span>{testimonial.date}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-8 bg-white rounded-2xl px-8 py-6 shadow-md">
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-600">500+</div>
              <div className="text-sm text-gray-600 mt-1">만족한 고객</div>
            </div>
            <div className="w-px h-12 bg-gray-200"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-600">4.9/5.0</div>
              <div className="text-sm text-gray-600 mt-1">평균 평점</div>
            </div>
            <div className="w-px h-12 bg-gray-200"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-600">98%</div>
              <div className="text-sm text-gray-600 mt-1">재구매율</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
